// src/components/Feedback/Feedback.js
import React, { useState, useEffect } from 'react';
import { Box, Button, Paper, Typography, Grid, Snackbar, Alert } from '@mui/material';
import CustomRichTextEditor from '../../extensions/RichTextEditor';
import excuseApi from '../../api/excuseApi';
import { getCurrentUser } from '../../models/Account';

const Feedback = () => {
  const [content, setContent] = useState('');
  const [user, setUser] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const API_BASE = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getCurrentUser().then(setUser);
  }, []);

  const processImage = async (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;

    const mediaElements = div.querySelectorAll('img, video source');
    for (let el of mediaElements) {
      const src = el.getAttribute('src');
      if (src && src.startsWith('data:')) {
        const response = await fetch(src);
        const blob = await response.blob();
        const file = new File([blob], 'upload', { type: blob.type });

        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });

        const isImage = file.type.startsWith('image/');
        const bodyKey = isImage ? 'image' : 'video';

        const res = await fetch(`${API_BASE}/upload-article-image`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ [bodyKey]: base64 }),
        });

        const data = await res.json();
        if (data.url) {
          el.setAttribute('src', data.url);
        }
      }
    }
    return div.innerHTML;
  };

  const handleSendFeedback = async () => {
    if (!user) {
      setSnackbar({ open: true, message: 'Bạn cần đăng nhập để gửi phản hồi', severity: 'warning' });
      return;
    }
    if (!content.trim()) {
      setSnackbar({ open: true, message: 'Vui lòng nhập nội dung', severity: 'warning' });
      return;
    }

    try {
      const processed = await processImage(content);
      const res = await excuseApi({
        endpoint: '/feedback',
        method: 'POST',
        data: { account_id: user.id, content: processed },
      });
      setSnackbar({ open: true, message: 'Gửi phản hồi thành công!', severity: 'success' });
      setContent('');
    } catch (err) {
      setSnackbar({ open: true, message: 'Có lỗi xảy ra khi gửi phản hồi', severity: 'error' });
    }
  };

  return (
    <>
      <Grid container spacing={2} justifyContent="center" sx={{ mb: 10 }}>
        <Grid item xs={2}></Grid>

        <Grid item xs={8}>
          <Paper sx={{ p: 3, bgcolor: '#8a0000', color: '#fbf7e4', borderRadius: 2, mt: 4 }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                mb: 2,
                fontFamily: '"Be Vietnam Pro", sans-serif',
              }}
            >
              GỬI PHẢN HỒI
            </Typography>

            <Box sx={{
              bgcolor: '#fbf7e4',
              borderRadius: 1,
              p: 1,
              color: '#4a5933',
              minHeight: 150,
              mb: 2,
            }}>
              <CustomRichTextEditor value={content} onChange={setContent} showToolbar={false}/>
            </Box>

            <Button
              variant="contained"
              sx={{
                bgcolor: 'black',
                fontWeight: 'bold',
                px: 3,
                py: 1,
                '&:hover': { bgcolor: '#364623' },
              }}
              onClick={handleSendFeedback}
            >
              Gửi phản hồi
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={2}></Grid>
      </Grid>

      {/* Snackbar thông báo */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{
            width: '400px',
            fontSize: '1rem',
            fontWeight: 'bold',
            textAlign: 'center',
            bgcolor:
              snackbar.severity === 'success'
                ? '#4caf50'
                : snackbar.severity === 'warning'
                  ? '#ff9800'
                  : '#f44336',
            color: '#fff',
            boxShadow: 3,
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Feedback;
